<template>
  <div :style="{ 'background-color': backgroundColor }" style="height: 100%">
    <b-container>
      <b-row>
        <b-col>
          <h2>{{ $t(title) }}</h2>
        </b-col>
      </b-row>
      <b-row
        v-if="getCurrentSnapshot.status !== 'label_configuration_snapshot_accepted'"
      >
        <b-col lg="1" />
        <b-col>
          <b-input-group>
            <h3>{{ $t("label_surveyManagement_invitationLink") }}:</h3>
            <b-form-input
              id="invitationLink"
              :value="invitationLink"
              readonly
            />
            <b-btn variant="primary" class="outline-secondary" @click="copyToClipboard()">
              {{ $t("label_surveyManagement_copyInvitationLink") }}
            </b-btn>
          </b-input-group>
        </b-col>
        <b-col lg="2">
          <div class="invitation-language text-right" style="padding-top: 7px">
            <b-form-select
              v-model="selectedLanguage"
              :options="languageOptions"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="filters">
        <b-col lg="11">
          <b-row>
            <b-col col>
              <b-form-group
                :label="$t('label_surveyManagement_invitation_column')"
              >
                <b-form-input v-model="filterEmail" />
              </b-form-group>
            </b-col>
            <b-col col>
              <date-range-picker
                v-model="dateRangeSent"
                :label="'label_surveyManagement_dataSent_filter'"
              />
            </b-col>
            <b-col col>
              <date-range-picker
                v-model="dateRangeExpired"
                :label="'label_surveyManagement_dataExpires_filter'"
              />
            </b-col>
            <b-col col>
              <date-range-picker
                v-model="dateRangeUpdated"
                :label="'label_surveyManagement_lastUpdate_filter'"
              />
            </b-col>
            <b-col col>
              <b-form-group :label="$t('label_surveyManagement_status_filter')">
                <b-form-select
                  v-model="filterStatus"
                  @change="getInvitationsData()"
                >
                  <option value="" />
                  <option value="new">
                    {{ $t("optionList_surveyManagement_status_new") }}
                  </option>
                  <option value="complete">
                    {{ $t("optionList_surveyManagement_status_complete") }}
                  </option>
                  <option value="open">
                    {{ $t("optionList_surveyManagement_status_open") }}
                  </option>
                  <option value="expired">
                    {{ $t("optionList_surveyManagement_status_expired") }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="1">
          <b-button style="margin-top: 30px" variant="primary" @click="clearFilters()">
            {{ $t("label_surveyManagement_clean_filter") }}
          </b-button>
        </b-col>
      </b-row>
      <!-- Statics -->
      <div class="statistics">
        <b-row>
          <b-col md="3">
            <p>
              {{ $t("label_surveyManagement_summary_invitations") }}
              <span class="filtered">{{
                statisticsFilter.invitations.total
              }}</span>
              (<span class="filtered"
                >{{ statisticsFilter.invitations.perc }}%</span
              >) {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics.invitations.total }}</span> (<span
                >{{ statistics.invitations.perc }}%</span
              >)
            </p>
          </b-col>

          <b-col md="3">
            <p>
              {{ $t("label_reports_graph_gender_women") }}
              <span class="filtered">{{ statisticsFilter.female.total }}</span>
              (<span class="filtered">{{ statisticsFilter.female.perc }}%</span
              >) {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics?.female?.total }}</span> (<span
                >{{ statistics?.female?.perc }}%</span
              >)
            </p>
          </b-col>
          <b-col md="3">
            <p>
              {{ $t("label_reports_graph_gender_men") }}
              <span class="filtered">{{ statisticsFilter.male.total }}</span>
              (<span class="filtered">{{ statisticsFilter.male.perc }}%</span>)
              {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics?.male?.total }}</span> (<span
                >{{ statistics?.male?.perc }}%</span
              >)
            </p>
          </b-col>

          <b-col md="3">
            <p>
              {{ $t("label_surveyManagement_summary_expired") }}
              <span class="filtered">{{ statisticsFilter.expired.total }}</span>
              (<span class="filtered">{{ statisticsFilter.expired.perc }}%</span
              >) {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics.expired.total }}</span> (<span
                >{{ statistics.expired.perc }}%</span
              >)
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <p>
              {{ $t("label_surveyManagement_summary_new") }}
              <span class="filtered">{{ statisticsFilter.new.total }}</span>
              (<span class="filtered">{{ statisticsFilter.new.perc }}%</span>)
              {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics.new.total }}</span> (<span
                >{{ statistics.new.perc }}%</span
              >)
            </p>
          </b-col>
          <b-col md="4">
            <p>
              {{ $t("label_surveyManagement_summary_open") }}
              <span class="filtered">{{ statisticsFilter.open.total }}</span>
              (<span class="filtered">{{ statisticsFilter.open.perc }}%</span>)
              {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics.open.total }}</span> (<span
                >{{ statistics.open.perc }}%</span
              >)
            </p>
          </b-col>
          <b-col md="4">
            <p>
              {{ $t("label_surveyManagement_summary_complete") }}
              <span class="filtered">{{
                statisticsFilter.complete.total
              }}</span>
              (<span class="filtered"
                >{{ statisticsFilter.complete.perc }}%</span
              >) {{ $t("label_surveyManagement_summary_prepositionOf") }}
              <span>{{ statistics.complete.total }}</span> (<span
                >{{ statistics.complete.perc }}%</span
              >)
            </p>
          </b-col>
        </b-row>
      </div>
      <!-- Main table element -->
      <div v-if="selectAll === 'filtered' || selected.length > 0" class="bulk">
        <b-row>
          <b-col>
            <div class="title">
              {{ $t("label_surveyManagement_bulkActions_caption") }}
            </div>
          </b-col>
          <b-col>
            <b-button
              v-if="['', 'expired'].includes(filterStatus)"
              size="sm"
              variant="link"
              class="mr-1"
              @click.stop="openModal(0, 0, 'multiple', 'renewInvitations')"
            >
              <icon name="share-square" scale="1.4" />
              {{ $t("label_surveyManagement_bulkActions_renewInvitations") }}
            </b-button>
          </b-col>
          <b-col>
            <b-button
              v-if="['', 'new', 'expired'].includes(filterStatus)"
              size="sm"
              variant="link"
              class="mr-1"
              @click.stop="openModal(0, 0, 'multiple', 'deleteInvitations')"
            >
              <icon name="trash" scale="1.4" />
              {{ $t("label_surveyManagement_bulkActions_deleteInvitations") }}
            </b-button>
          </b-col>
          <b-col>
            <b-button
              v-if="['', 'new', 'open'].includes(filterStatus)"
              size="sm"
              variant="link"
              class="mr-1"
              @click.stop="openModal(0, 0, 'multiple', 'resendInvitations')"
            >
              <icon name="envelope" scale="1.4" />
              {{ $t("label_surveyManagement_bulkActions_resendInvitations") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div
        v-if="selectAll === 'filtered' || selected.length > 0"
        class="bulk bulk-small"
      >
        <span v-if="selectAll === ''"> {{ selected.length }} </span>
        <span v-if="selectAll === 'filtered'">{{
          totalSeleccionablesFiltradas
        }}</span>
        seleccionadas de
        {{ totalSeleccionables }}
      </div>
      <b-table
        show-empty
        striped
        hover
        bordered
        stacked="md"
        class="invitations-table"
        :busy.sync="isBusy"
        :items="invitationsData"
        :fields="fields"
        :current-psent="currentPsent"
        :sort-direction="sortDirection"
        :per-page="0"
        :current-page="1"
      >
        <template slot="bottom-row" slot-scope="">
          <td colspan="7">
            {{ totalFilteredInvitations }} filtradas de {{ totalInvitations }}
          </td>
        </template>

        <template #head(isSelected)="">
          <input
            v-model="selectAllScreen"
            type="checkbox"
            :checked="selectAllScreen"
            :true-value="true"
            :false-value="false"
          />
          <b-dropdown
            id="dropdown-dropup"
            ref="ddown"
            no-caret
            dropup
            toggle-class="hiddenToggle"
            text=""
            variant="primary"
            class="m-2"
          >
            <b-dropdown-item @click="checkAllScreen(true)">
              {{ $t("label_surveyManagement_bulkActions_selectVisible") }}
            </b-dropdown-item>
            <b-dropdown-item @click="selectAllInvitations('filtered')">
              {{ $t("label_surveyManagement_bulkActions_selectAll") }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <template #head(email)="">
          {{ $t("label_surveyManagement_invitation_column") }}
        </template>
        <template #head(sent)="">
          {{ $t("label_surveyManagement_dateSent_column") }}
        </template>
        <template #head(expires)="">
          {{ $t("label_surveyManagement_dateExpires_column") }}
        </template>
        <template #head(lastUpdate)="">
          {{ $t("label_surveyManagement_lastUpdate_column") }}
        </template>
        <template #head(status)="">
          {{ $t("label_surveyManagement_status_column") }}
        </template>
        <template #head(actions)="">
          {{ $t("label_surveyManagement_actions_column") }}
        </template>
        <template
          v-if="
            getCurrentSnapshot.status !==
            'label_configuration_snapshot_accepted'
          "
          #cell(isSelected)="row"
        >
          <input
            v-if="
              row.item.status == 'expired' ||
              row.item.status == 'new' ||
              row.item.status == 'open'
            "
            v-model="row.item.isSelected"
            type="checkbox"
            :checked="row.item.isSelected"
            :true-value="true"
            :false-value="false"
            @change="addRemoveSelected(row.item.id, row.item.isSelected)"
          />
        </template>
        <template #cell(email)="row">
          {{ row.item.email ? row.item.email : row.item.accessNumber }}
        </template>
        <template #cell(sent)="row">
          {{ row.item.sent | moment("DD/MM/YYYY") }}
        </template>
        <template #cell(expires)="row">
          {{ row.item.expires | moment("DD/MM/YYYY") }}
        </template>
        <template #cell(lastUpdate)="row">
          {{ row.item.lastUpdate | moment("DD/MM/YYYY") }}
        </template>
        <template #cell(status)="row">
          {{ $t("optionList_surveyManagement_status_" + row.value) }}
        </template>
        <template
          v-if="
            getCurrentSnapshot.status !==
            'label_configuration_snapshot_accepted'
          "
          #cell(actions)="row"
        >
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            v-if="
              row.item.email &&
              row.item.status != 'complete' &&
              row.item.status != 'expired'
            "
            size="sm"
            variant="link"
            class="mr-1"
            @click.stop="
              openModal(row.item, row.index, 'simple', 'resendInvitations')
            "
          >
            <icon name="envelope" scale="1.4" />
          </b-button>
          <b-button
            v-if="row.item.status == 'expired'"
            size="sm"
            variant="link"
            class="mr-1"
            @click.stop="
              openModal(row.item, row.index, 'simple', 'renewInvitations')
            "
          >
            <icon name="share-square" scale="1.4" />
          </b-button>
          <b-button
            v-if="row.item.status == 'expired' || row.item.status == 'new'"
            size="sm"
            variant="link"
            @click.stop="
              openModal(row.item, row.index, 'simple', 'deleteInvitations')
            "
          >
            <icon name="trash" scale="1.4" />
          </b-button>
        </template>
        <template slot="empty">
          <div role="alert" aria-live="polite">
            <div class="text-center my-2">
              {{ $t("label_surveyManagement_noRecordsToShow") }}
            </div>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col />
        <b-col>
          <b-pagination
            v-model="currentPage"
            align="center"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @input="getInvitationsData(false)"
          />
        </b-col>
        <b-col col>
          <b-form-group>
            <b-form-select
              v-model="perPage"
              @change="getInvitationsData(false)"
            >
              <option value="5">
                {{ $t("optionList_surveyManagement_pagination_5") }}
              </option>
              <option value="15">
                {{ $t("optionList_surveyManagement_pagination_15") }}
              </option>
              <option value="50">
                {{ $t("optionList_surveyManagement_pagination_50") }}
              </option>
              <option value="100">
                {{ $t("optionList_surveyManagement_pagination_100") }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Info modal -->
      <b-modal
        id="modalInfo"
        v-model="showModal"
        modal-class="modalInfo"
        :title="$t(modalInfo.title)"
      >
        <p>{{ $t(modalInfo.content) }}</p>
        <div slot="modal-footer" class="w-100">
          <b-btn variant="primary" @click="resetModal()">
            {{ $t("label_surveyManagement_confirmation_no") }}
          </b-btn>
          <b-btn
            variant="primary"
            @click="okModal(modalInfo.action, modalInfo.type)"
          >
            {{ $t("label_surveyManagement_confirmation_yes") }}
          </b-btn>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { axiosCall } from "@/utils/axiosCall";
import {getSurveyUrl} from "@/utils/urlConfig";

export default {
  name: "SurveyManagement",
  props: {
    templateId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "label_surveyManagement_title",
    },
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
  },
  data() {
    return {
      getInvitationsStatistics: { statistics: {} },
      statistics: {
        male: { total: 0, perc: 0 },
        female: { total: 0, perc: 0 },
        invitations: {
          total: 0,
          perc: 0,
        },
        expired: {
          total: 0,
          perc: 0,
        },
        new: {
          total: 0,
          perc: 0,
        },
        open: {
          total: 0,
          perc: 0,
        },
        complete: {
          total: 0,
          perc: 0,
        },
      },
      statisticsFilter: {
        male: { total: 0, perc: 0 },
        female: { total: 0, perc: 0 },
        invitations: {
          total: 0,
          perc: 0,
        },
        expired: {
          total: 0,
          perc: 0,
        },
        new: {
          total: 0,
          perc: 0,
        },
        open: {
          total: 0,
          perc: 0,
        },
        complete: {
          total: 0,
          perc: 0,
        },
      },
      selected: [],
      dateRangeSent: {
        startDate: null,
        endDate: null,
      },
      dateRangeExpired: {
        startDate: null,
        endDate: null,
      },
      dateRangeUpdated: {
        startDate: null,
        endDate: null,
      },
      perPage: 15,
      currentPage: 1,
      fields: [
        { key: "isSelected" },
        { key: "email", sortable: true, sortDirection: "desc" },
        {
          key: "sent",
          label: "Date sent",
          sortable: true,
          class: "text-center",
        },
        {
          key: "expires",
          label: "Date expires",
          sortable: true,
          class: "text-center",
        },
        {
          key: "lastUpdate",
          label: "Late Update",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center",
        },
        { key: "actions", label: "Actions" },
      ],
      invitationsData: [],
      rows: 1,
      isAllInvitationsSelected: false,
      showBulk: false,
      invitations: [],
      currentPsent: 1,
      perPsent: 20,
      totalRows: 10,
      sortDirection: "asc",
      filterEmail: "",
      filterAccessNumber: "",
      filterSent: "",
      filterExpires: "",
      filterLastUpdate: "",
      filterStatus: "",
      modalInfo: {
        title: "",
        content: "",
        action: "",
        type: "",
        currentObject: {},
      },
      showModal: false,
      isBusy: false,
      selectAll: "",
      selectAllScreen: false,
      totalInvitations: 0,
      totalFilteredInvitations: 0,
      totalSeleccionables: 0,
      totalSeleccionablesFiltradas: 0,
      selectedLanguage: "en",
      languageOptions: [],
    };
  },
  watch: {
    getLang: async function () {
      this.fillLanguages();
    },
    selectAllScreen: function () {
      if (this.selectAllScreen === false) {
        this.checkAllScreen(true);
      } else {
        this.$refs.ddown.visible = true;
      }
    },
    dateRangeSent: function () {
      this.getInvitationsData();
    },
    dateRangeExpired: function () {
      this.getInvitationsData();
    },
    dateRangeUpdated: function () {
      this.getInvitationsData();
    },
    filterEmail: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getInvitationsData();
      }, 500);
    },
  },
  methods: {
    fillLanguages() {
      this.languageOptions = [
        { value: "en", text: this.$t("headerMenu_language_english_caption") },
        { value: "es", text: this.$t("headerMenu_language_spanish_caption") },
        {
          value: "pt",
          text: this.$t("headerMenu_language_portuguese_caption"),
        },
      ];
      if (this.templateId !== "ViolenceSurvey") {
        this.languageOptions.push({
          value: "tr",
          text: this.$t("headerMenu_language_turkish_caption"),
        });
        this.languageOptions.push({
          value: "bs",
          text: this.$t("headerMenu_language_bosnian_caption"),
        });
      }
    },
    selectAllInvitations(selectAll) {
      this.selectAllScreen = true;
      this.selectAll = selectAll;
      this.checkAllScreen();
    },
    checkAllScreen(clearSelectAll = false) {
      if (clearSelectAll) {
        this.selectAll = "";
      }
      this.selected = [];
      this.invitationsData.map((invitation) => {
        if (
          invitation.status === "expired" ||
          invitation.status === "new" ||
          invitation.status === "open"
        ) {
          invitation.isSelected = this.selectAllScreen;
          this.addRemoveSelected(invitation.id, this.selectAllScreen);
        }
      });
    },
    openModal(item, index, type, action) {
      this.showModal = true;
      this.modalInfo.title = "label_surveyManagement_bulkActions_" + action;
      this.modalInfo.content = "label_surveyManagement_confirmation_" + action;
      this.modalInfo.action = action;
      this.modalInfo.type = type;
      this.modalInfo.currentObject = { item, index };
      // this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    addRemoveSelected(id, add) {
      if (add) {
        this.selected.push(id);
      } else {
        this.selected = this.selected.filter((s) => s !== id);
      }
    },
    resetModal() {
      this.showModal = false;
      this.modalInfo.title = "";
      this.modalInfo.content = "";
      this.modalInfo.action = "";
      this.modalInfo.currentObject = {};
    },
    okModal(action, type) {
      var invitations = [];
      if (type === "simple") {
        invitations.push(this.modalInfo.currentObject.item.id);
      } else {
        // Multiple invitations
        for (var i in this.invitationsData) {
          if (this.invitationsData[i].isSelected === true) {
            if (this.modalInfo.action === "deleteInvitations") {
              invitations.push(this.invitationsData[i].id);
            } else if (
              this.modalInfo.action === "renewInvitations" &&
              this.invitationsData[i].status === "expired"
            ) {
              invitations.push(this.invitationsData[i].id);
            } else if (
              this.modalInfo.action === "resendInvitations" &&
              this.invitationsData[i].email
            ) {
              invitations.push(this.invitationsData[i].id);
            }
          }
        }
      }
      this.invitationsAction(invitations, action);
      this.showModal = false;
      this.modalInfo.title = "";
      this.modalInfo.content = "";
      this.modalInfo.action = "";
      this.modalInfo.currentObject = {};
    },
    invitationsAction(invitationsId, action) {
      var data = {
        invitationsId: invitationsId,
        filters: {
          dateRangeSent: this.dateRangeSent,
          dateRangeExpired: this.dateRangeExpired,
          dateRangeUpdated: this.dateRangeUpdated,
          filterEmail: this.filterEmail,
          filterStatus: this.filterStatus,
          selected: this.selectAll,
        },
        templateId: this.templateId,
      };
      const actions = {
        renewInvitations: "INVITATION_RENEW",
        deleteInvitations: "INVITATION_REMOVEIDS",
        resendInvitations: "INVITATION_RESEND",
      };
      this.$store
        .dispatch(actions[action], data)
        .then(() => {
          this.getInvitationsData(false);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateChekbox() {
      this.showBulk = false;
      for (var i in this.invitationsFiltered) {
        if (this.invitationsFiltered[i].isSelected === true) {
          this.showBulk = true;
        }
      }
    },
    selectVisible() {
      this.invitationsData.map((s) => {
        s.isSelected = true;
      });
    },
    myProvider() {
      const items = this.getInvitations;
      return items || [];
    },
    copyToClipboard() {
      document.getElementById("invitationLink").select();
      document.execCommand("copy");
    },
    clearFilters() {
      this.filterEmail = "";
      this.filterAccessNumber = "";
      this.filterStatus = "";
      this.dateRangeSent = {
        startDate: null,
        endDate: null,
      };
      this.dateRangeExpired = {
        startDate: null,
        endDate: null,
      };
      this.dateRangeUpdated = {
        startDate: null,
        endDate: null,
      };
    },
    getInvitationsData(clearSelected = true) {
      if (clearSelected) {
        this.selectAll = "";
        this.selectAllScreen = false;
        this.totalInvitations = 0;
        this.totalFilteredInvitations = 0;
        this.totalSeleccionablesFiltradas = 0;
        this.selected = [];
      }
      const data = {
        page: this.currentPage,
        pageSize: this.perPage,
        dateRangeSent: this.dateRangeSent,
        dateRangeExpired: this.dateRangeExpired,
        dateRangeUpdated: this.dateRangeUpdated,
        filterEmail: this.filterEmail,
        filterStatus: this.filterStatus,
      };
      if (this.getCurrentSnapshot.snapshotId && this.templateId) {
        axiosCall({
          url: `Invitations/getPaginated/${this.getCurrentSnapshot.snapshotId}/${this.templateId}?showSpinner=true`,
          method: "POST",
          data,
        })
          .then((resp) => {
            this.invitationsData = resp.data.invitations.invitations;
            const statistics = resp.data.invitations.statistics;
            this.rows = resp.data.invitations.totalInvitationsFiltered;

            this.totalInvitations = resp.data.invitations.totalInvitations;
            this.totalFilteredInvitations =
              resp.data.invitations.totalInvitationsFiltered;

            const totalFilteredDiv =
              resp.data.invitations.totalInvitations > 0
                ? resp.data.invitations.totalInvitations
                : 1;
            if (!statistics["expired"]) {
              statistics["expired"] = 0;
            }
            if (!statistics["new"]) {
              statistics["new"] = 0;
            }
            if (!statistics["open"]) {
              statistics["open"] = 0;
            }
            if (!statistics["complete"]) {
              statistics["complete"] = 0;
            }
            this.statisticsFilter = {
              invitations: {
                total: resp.data.invitations.totalInvitationsFiltered,
                perc:
                  resp.data.invitations.totalInvitations > 0
                    ? parseInt(
                        (resp.data.invitations.totalInvitationsFiltered * 100) /
                          resp.data.invitations.totalInvitations
                      )
                    : 0,
              },
              expired: {
                total: statistics["expired"],
                perc: parseInt(
                  (statistics["expired"] * 100) / totalFilteredDiv
                ),
              },
              female: {
                total:
                  statistics[
                    "optionList_opinionSurvey_basicInformation_qA_sex_female"
                  ].filtered,
                perc: parseInt(
                  (statistics[
                    "optionList_opinionSurvey_basicInformation_qA_sex_female"
                  ].filtered *
                    100) /
                    totalFilteredDiv
                ),
              },
              male: {
                total:
                  statistics[
                    "optionList_opinionSurvey_basicInformation_qA_sex_male"
                  ].filtered,
                perc: parseInt(
                  (statistics[
                    "optionList_opinionSurvey_basicInformation_qA_sex_male"
                  ].filtered *
                    100) /
                    totalFilteredDiv
                ),
              },
              new: {
                total: statistics["new"],
                perc: parseInt((statistics["new"] * 100) / totalFilteredDiv),
              },
              open: {
                total: statistics["open"],
                perc: parseInt((statistics["open"] * 100) / totalFilteredDiv),
              },
              complete: {
                total: statistics["complete"],
                perc: parseInt(
                  (statistics["complete"] * 100) / totalFilteredDiv
                ),
              },
            };
            this.statistics.female = {
              total:
                statistics[
                  "optionList_opinionSurvey_basicInformation_qA_sex_female"
                ].total,
              perc: parseInt(
                (statistics[
                  "optionList_opinionSurvey_basicInformation_qA_sex_female"
                ].total *
                  100) /
                  totalFilteredDiv
              ),
            };
            this.statistics.male = {
              total:
                statistics[
                  "optionList_opinionSurvey_basicInformation_qA_sex_male"
                ].total,
              perc: parseInt(
                (statistics[
                  "optionList_opinionSurvey_basicInformation_qA_sex_male"
                ].total *
                  100) /
                  totalFilteredDiv
              ),
            };
            if (this.selected.length > 0) {
              this.invitationsData.map((invData) => {
                if (this.selected.includes(invData.id)) {
                  invData.isSelected = true;
                }
              });
            }
            this.totalSeleccionablesFiltradas =
              statistics["new"] + statistics["open"] + statistics["expired"];
            if (this.selectAll !== "") {
              this.checkAllScreen();
            }
          })
          .catch(() => {
          });
      } else {
      }
    },
  },
  computed: {
    invitationLink: function () {
      return (
        getSurveyUrl(this.selectedLanguage) +
        "/" +
        this.getCurrentSnapshot.snapshotId +
        "?s=" +
        this.templateId
      );
    },
    invitationsFiltered: function () {
      var filtered = this.getInvitations;
      return filtered;
    },
    ...mapGetters([
      "getInvitations",
      "getCurrentSnapshot",
      "getLang",
      "getUserAccount",
    ]),
  },
  mounted() {
    this.selectedLanguage = this.languageOptions.find(
      (option) => option.value === this.getUserAccount.languageIdentifier
    )
      ? this.getUserAccount.languageIdentifier
      : "en";
  },
  created() {
    this.$store.dispatch("SNAPSHOTS_GET").then(() => {
      this.$store.dispatch("BUSINESS_GET").then(() => {
        this.getInvitationsData();
        if (this.getCurrentSnapshot.snapshotId && this.templateId) {
          axiosCall({
            url: `Invitations/getStatistics/${this.getCurrentSnapshot.snapshotId}/${this.templateId}`,
          })
            .then((s) => {
              this.getInvitationsStatistics = s.data.invitations;
              if (!this.getInvitationsStatistics.statistics["expired"]) {
                this.getInvitationsStatistics.statistics["expired"] = 0;
              }
              if (!this.getInvitationsStatistics.statistics["new"]) {
                this.getInvitationsStatistics.statistics["new"] = 0;
              }
              if (!this.getInvitationsStatistics.statistics["open"]) {
                this.getInvitationsStatistics.statistics["open"] = 0;
              }
              if (!this.getInvitationsStatistics.statistics["complete"]) {
                this.getInvitationsStatistics.statistics["complete"] = 0;
              }
              this.statistics = {
                invitations: {
                  total: this.getInvitationsStatistics.total,
                  perc: 100,
                },
                expired: {
                  total: this.getInvitationsStatistics.statistics["expired"],
                  perc:
                    this.getInvitationsStatistics.total > 0
                      ? parseInt(
                          (this.getInvitationsStatistics.statistics["expired"] *
                            100) /
                            this.getInvitationsStatistics.total
                        )
                      : 0,
                },
                new: {
                  total: this.getInvitationsStatistics.statistics["new"],
                  perc:
                    this.getInvitationsStatistics.total > 0
                      ? parseInt(
                          (this.getInvitationsStatistics.statistics["new"] *
                            100) /
                            this.getInvitationsStatistics.total
                        )
                      : 0,
                },
                open: {
                  total: this.getInvitationsStatistics.statistics["open"],
                  perc:
                    this.getInvitationsStatistics.total > 0
                      ? parseInt(
                          (this.getInvitationsStatistics.statistics["open"] *
                            100) /
                            this.getInvitationsStatistics.total
                        )
                      : 0,
                },
                complete: {
                  total: this.getInvitationsStatistics.statistics["complete"],
                  perc:
                    this.getInvitationsStatistics.total > 0
                      ? parseInt(
                          (this.getInvitationsStatistics.statistics[
                            "complete"
                          ] *
                            100) /
                            this.getInvitationsStatistics.total
                        )
                      : 0,
                },
              };
              this.totalSeleccionables =
                this.getInvitationsStatistics.statistics["new"] +
                this.getInvitationsStatistics.statistics["open"] +
                this.getInvitationsStatistics.statistics["expired"];
            })
            .catch(() => {});
        } else {
        }
      });
    });
    this.fillLanguages();
  },
};
</script>

<style lang="scss" scoped>

/* components/OpinionSurveyManagment */
@import "../assets/css/variables.scss";

h2 {
  margin-bottom: 30px;
}
h3 {
  font-size: 1.5rem;
  margin-right: 15px;
  color: $accent-color;
  margin-top: 13px;
}

.input-group {
  border: 0;
}
.input-group > .form-control {
  background-color: $accent-color !important;
  border-radius: 20px;
  color: #fff;
  font-size: 20px;
  margin-bottom: 25px;
  text-align: center;
}
.outline-secondary {
  margin-left: 15px;
  font-size: 1.2rem;
  margin-top: 6px;
  height: 40px;
}
.btn-secondary {
  border-radius: 10px;
  margin-top: 2rem;
}
.statistics {
  text-align: center;
  font-weight: bold;
  background-color: #f1f2f2;
  padding-top: 10px;
  span {
    color: $accent-color;
    &.filtered {
      color: $primary-color;
    }
  }
}
.bulk-small {
  font-size: 0.9em;
}
.bulk {
  min-height: 35px;
  background-color: $accent-color;
  text-align: center;
  font-family: $font-title;
  color: #fff;
  font-size: 1.2rem;
  .title {
    margin-top: 4px;
  }
  .btn-link {
    color: #fff;
    font-size: 1.2rem;
    padding: 0px;
  }
}
.select-all-bulk {
  position: relative;
  input {
    position: absolute;
    top: 12px;
    z-index: 1000;
    left: 22px;
  }
}
.selectBar {
  background-color: $accent-color;
  color: #FFFFFF;
  .select {
    font-size: 13px;
    font-weight: 100;
    padding: 5px;
  }
}
.hiddenToggle {
  position: relative !important;
  background: #000000;
  border: none;
  height: 1px;
  width: 1px;
}
div#dropdown-dropup {
  height: 1px;
  width: 1px;
  padding: 0;
  margin: 0 !important;
  position: relative;
}
@media (max-width: 768px) {
  .btn-secondary {
    margin-top: 0;
    margin-bottom: 1rem;
  }
};
</style>
